var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { flatten } from '../../../utils/helper/lodash_replacements';
export class ActorTraits {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get allOwnTraits() {
        return flatten(this.actor.actorAspects.aspectsWithTraits.map(aspect => aspect.traits));
    }
    get allOwnTraitsThatHaveInnerTraits() {
        return this.allOwnTraits.filter((trait) => trait.actorTraits.hasOwnTraits);
    }
    get hasOwnTraits() {
        return this.allOwnTraits.length > 0;
    }
    allOwnTraitsOfKey(traitKey) {
        return this.allOwnTraits.filter(trait => trait.key === traitKey);
    }
    allOwnAttachedTraitsOfKey(traitKey) {
        return this.allOwnTraitsOfKey(traitKey).map(trait => trait.toAttached);
    }
}
__decorate([
    computed
], ActorTraits.prototype, "allOwnTraitsThatHaveInnerTraits", null);
__decorate([
    computed
], ActorTraits.prototype, "hasOwnTraits", null);
